import React from "react";
import styles from "./Overview.module.css";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import faker from "faker";
import UpcomingOutlinedIcon from "@mui/icons-material/UpcomingOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PeopleIcon from "@mui/icons-material/People";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { Divider } from "@mui/material";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
const labels = ["S", "M", "T", "W", "T", "F", "S"];
const labels1 = ["Nov 1", "Nov 4", "Nov 8", "Nov 12", "Nov 16"];
export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        callback: function (value, index, ticks) {
          return "$" + value;
        },
      },
    },
  },
};
export const options1 = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
    },
  },
};
export const options2 = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
};

export const data = {
  labels: labels1,
  datasets: [
    {
      fill: true,
      data: labels.map(() => faker.datatype.number({ min: 0, max: 40 })),
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
      tension: 0.4,
    },
  ],
};
export const datas = {
  labels,
  datasets: [
    {
      data: labels.map(() => faker.datatype.number({ min: 0, max: 30 })),
      backgroundColor: "rgb(0,209,255)",
    },
    {
      data: labels.map(() => faker.datatype.number({ min: 0, max: 30 })),
      backgroundColor: "rgb(0,56,255)",
    },
  ],
};
const Overview = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container2}>
        <div className={styles.navbar}>
          <h2>Hello, John 👋</h2>
          <input className={styles.search} placeholder="Search" type="search" />
        </div>
        <div className={styles.graph1}>
          <div className={styles.analytics}>
            <h3>Analytics</h3>
            <div className={styles.analyt}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "3%",
                    borderRadius: "14px",
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  Income
                  <ArrowDownwardIcon style={{ color: "ffffff" }} />
                </button>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p>Sort By</p>
                  <button
                    style={{
                      marginLeft: "5px",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "14px",
                      color: "black",
                      backgroundColor: "white",
                      border: 0,
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    Month <ArrowDownwardIcon style={{ color: "black" }} />
                  </button>
                </div>
              </div>
              <Line data={data} options={options} />
            </div>
          </div>
          <div className={styles.reminder}>
            <h3>Reminder</h3>
            <div className={styles.remcard}>
              <h2>Agency Design Kit</h2>
              <div className={styles.figma}>
                <img
                  alt=""
                  width="60px"
                  height="60px"
                  src="https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg"
                />
              </div>
              <h3>Will be published</h3>
              <h3 style={{ marginTop: "-7px" }}>Nov 25, 2022</h3>
              <button
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: 0,
                  paddingTop: "4%",
                  paddingBottom: "4%",
                  paddingLeft: "12%",
                  paddingRight: "12%",
                }}
              >
                Set as Reminder
              </button>
            </div>
          </div>
        </div>
        <div className={styles.graph2}>
          <div className={styles.tran}>
            <h3>Recent Transaction</h3>
            <div className={styles.trans2}>
              <div className={styles.transcard}>
                <img
                  alt=""
                  width="50px"
                  height="50px"
                  src="https://cdn.dribbble.com/users/2345673/screenshots/9068976/media/1562eb26103edcfd3a7aac1937b0b5f4.png"
                />
                <div>
                  <h3>Jiko Mobile App</h3>
                  <p style={{ marginTop: "-6px" }}>12 Nov 2021 4:45AM</p>
                </div>
                <h3>$15</h3>
              </div>
              <div className={styles.transcard}>
                <img
                  alt=""
                  width="50px"
                  height="50px"
                  src="https://cdn.dribbble.com/users/2345673/screenshots/9068976/media/1562eb26103edcfd3a7aac1937b0b5f4.png"
                />
                <div>
                  <h3>Jiko Mobile App</h3>
                  <p style={{ marginTop: "-6px" }}>12 Nov 2021 4:45AM</p>
                </div>
                <h3>$15</h3>
              </div>
              <div className={styles.transcard}>
                <img
                  alt=""
                  width="50px"
                  height="50px"
                  src="https://cdn.dribbble.com/users/2345673/screenshots/9068976/media/1562eb26103edcfd3a7aac1937b0b5f4.png"
                />
                <div>
                  <h3>Jiko Mobile App</h3>
                  <p style={{ marginTop: "-6px" }}>12 Nov 2021 4:45AM</p>
                </div>
                <h3>$15</h3>
              </div>
              <div className={styles.transcard}>
                <img
                  alt=""
                  width="50px"
                  height="50px"
                  src="https://cdn.dribbble.com/users/2345673/screenshots/9068976/media/1562eb26103edcfd3a7aac1937b0b5f4.png"
                />
                <div>
                  <h3>Jiko Mobile App</h3>
                  <p style={{ marginTop: "-6px" }}>12 Nov 2021 4:45AM</p>
                </div>
                <h3>$15</h3>
              </div>
            </div>
          </div>
          <div className={styles.recent}>
            <h3>Recent Transaction</h3>
            <div className={styles.recent2}>
              <p>Accounts reached</p>
              <h1>11,756</h1>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginRight: "5%",
                  marginLeft: "5%",
                }}
              >
                <p>Day</p>
                <p>Week</p>
                <p style={{ fontWeight: 700 }}>Month</p>
                <p>Year</p>
              </div>
              <Line data={data} options={options1} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.side}>
        <div className={styles.container3}>
          <MailOutlinedIcon style={{ fontSize: "45px", marginRight: "2%" }} />
          <UpcomingOutlinedIcon
            style={{ fontSize: "45px", marginRight: "2%" }}
          />
          <AccountCircleOutlinedIcon
            style={{ fontSize: "45px", marginRight: "2%" }}
          />
        </div>
        <div className={styles.earn}>
          <h3>Earnings</h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className={styles.earn2}>
              <p>Saved this month</p>
              <h1>$12,281</h1>
              <p>Your payment will be</p>
              <p style={{ marginTop: "-8px" }}>updated by the system</p>
              <div>
                <Bar data={datas} options={options2} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rece}>
          <h3>Recents Transactions</h3>
          <div className={styles.rece2}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PeopleIcon />
              <p>Transfer to your team</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <h2 style={{ color: "grey" }}>
                $<span style={{ color: "black" }}>450</span>
              </h2>
              <button
                style={{
                  backgroundColor: "blue",
                  border: "0",
                  color: "white",
                  borderRadius: "15px",
                  paddingTop: "5%",
                  paddingBottom: "5%",
                  paddingRight: "10%",
                  paddingLeft: "10%",
                }}
              >
                Transfer
              </button>
            </div>
            <Divider
              style={{ marginTop: "4%", marginLeft: "8%", marginRight: "8%" }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                marginLeft: "6%",
                marginTop: "8%",
              }}
            >
              <img
                width="15%"
                src="https://www.kindpng.com/picc/m/78-786207_user-avatar-png-user-avatar-icon-png-transparent.png"
                alt="pic"
              />
              <img
                width="15%"
                style={{ marginLeft: "-3%" }}
                src="https://www.kindpng.com/picc/m/163-1636340_user-avatar-icon-avatar-transparent-user-icon-png.png"
                alt="pic"
              />
              <img
                width="15%"
                style={{ marginLeft: "-3%" }}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSa69_HGc_i3MXKCPZzCfAjBZC4bXJsn0rS0Ufe6H-ctZz5FbIVaPkd1jCPTpKwPruIT3Q&usqp=CAU"
                alt="pic"
              />
              <img
                width="15%"
                style={{ marginLeft: "-3%" }}
                src="https://www.kindpng.com/picc/m/78-786207_user-avatar-png-user-avatar-icon-png-transparent.png"
                alt="pic"
              />
              <img
                width="15%"
                style={{ marginLeft: "-3%" }}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuoovVYEMl5PlyrnrmjPY_0bH_k0RaXYByiMVOWeEhWeG9wxWP2ozVw0Ab51hiQzxErpo&usqp=CAU"
                alt="pic"
              />
              <img
                width="15%"
                style={{ marginLeft: "-3%" }}
                src="https://d1nhio0ox7pgb.cloudfront.net/_img/o_collection_png/green_dark_grey/512x512/plain/add.png"
                alt="pic"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Overview;
